import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { SuccessMessageControl } from "@tlc/ls2pac/app/controls/successMessageControl";
import { AccountHolder } from "@tlc/ls2pac/components/Account";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import * as React from "react";
import { ListService, ListType } from "../ListService";

export interface DeleteListDialogProps {
  open: boolean;
  listId: number;
  listType: ListType;
  onClose: (deleted: boolean) => void;
  successMessage: string;
  errorMessage: string;
}
export const DeleteListDialog: React.FC<DeleteListDialogProps> = ({
  open,
  onClose,
  listId,
  listType,
  successMessage,
  errorMessage,
}) => {
  const { translate } = useLanguage();
  const [deleteError, setDeleteError] = React.useState<boolean>(false);

  return (
    <Dialog open={open} onClose={() => onClose(false)}>
      <DialogTitle>{translate("areYouSureTitle")}</DialogTitle>
      <DialogContent sx={{ pb: 0 }}>
        {deleteError && <Alert severity="error">{errorMessage}</Alert>}
        <DialogContentText>
          {translate("areYouSureRemoveList")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} type="button">
          {translate("cancel")}
        </Button>
        <Button
          onClick={async () => {
            setDeleteError(false);
            try {
              const success = await ListService.deleteList(listId, listType);

              if (success) {
                SuccessMessageControl.show(`1 ${successMessage}`);
                AccountHolder.fetchAccountSummaryAndPatron(true); // update account menu list count
                onClose(true);
              } else {
                setDeleteError(true);
              }
            } catch (e) {
              setDeleteError(true);
            }
          }}
          type="button"
        >
          {translate("delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
